export function setCookie(name, value, options = {}) {

    options = {
        path: '/',
        ...options
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = name + "=" + value;

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }
    document.cookie = updatedCookie;
}

export function deleteCookie(name) {
    setCookie(name, "", {
        'max-age': -1
    })
}

export function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setLoginCookies(cookies) {
    Object.keys(cookies).forEach(cookieName => {
        setCookie(cookieName, cookies[cookieName].value, cookies[cookieName].options)
    })
}

export function deleteLoginCookies() {
    let cookies = [
        'loggedIn',
        'accessToken',
        'refreshToken',
        'user_id',
        'is_email_confirmed',
        'user_name',
        'last_name',
        'first_name',
        'user_public_id'
    ]
    cookies.forEach(cookieName => {
        setCookie(cookieName, "", {'max-age': -1})
    })
}